import { NavigationPathComponentProps, NavigationPathComponentState} from './navigationpathcomponent';
import { NavigationPathCSSStyle } from './navigationpathcss';
import { UIComponentViewImpl } from '../../../toolkit/uicomponentview';
import { UIDataModel } from '../../../toolkit/uicomponent';
import * as React from 'react';
import './nav-path-style.css';

export class NavigationPathViewImpl extends UIComponentViewImpl<UIDataModel>
{
    draw(props: NavigationPathComponentProps, state: NavigationPathComponentState, cssStyle: NavigationPathCSSStyle): JSX.Element | boolean
    {
        super.draw(props, state, cssStyle);

        return (
            <>
                <div id="nav-path-web">
                    {
                        this.getWebView(props,state, cssStyle)
                    }
                </div> 
               
                <div id="nav-path-mobile">
                    {
                        this.getMobileView(props,state, cssStyle)
                    }
                </div>
                 
            </>
        );
    }

    getWebView(props: NavigationPathComponentProps, state: NavigationPathComponentState, cssStyle: NavigationPathCSSStyle)
    {
        return (
            <div style={cssStyle.getWrapperCSSStyle()}>
            {
                    state.listOfPaths.length === 1 
                     ?
                    <div key={0}>
                        <label style={cssStyle.getTitleCSSStyle()}>{state.listOfPaths[0]}</label>
                    </div>
                    :
                    state.listOfPaths.map((path: string, index: number) =>
                   {
                       return <div key={index}>
                           {index > 0 && <img  src={props.context.getResources().getImage("next_black.svg")} style={cssStyle.getArrowCSSStyle()}/>}
                            <label style={(state.listOfPaths.length - 1) === index ? cssStyle.getCurrentSelectedTitleCSSStyle() : cssStyle.getTitleCSSStyle()}>{path}</label>
                       </div>;
                   })
                }
            </div>
        );
    }

    getMobileView(props: NavigationPathComponentProps, state: NavigationPathComponentState, cssStyle: NavigationPathCSSStyle)
    {
        return (
            <div style={cssStyle.getMobileWrapperCSSStyle()}>
            {
                    state.listOfPaths.length === 1 
                     ?
                    <div key={0}>
                        <label style={cssStyle.getMobileTitleCSSStyle()}>{state.listOfPaths[0]}</label>
                    </div>
                    :
                    state.listOfPaths.map((path: string, index: number) =>
                   {
                       return <div key={index}>
                           {index > 0 && <img  src={props.context.getResources().getImage("next_black.svg")} style={cssStyle.getMobileArrowCSSStyle()}/>}
                            <label style={(state.listOfPaths.length - 1) === index ? cssStyle.getMobileCurrentSelectedTitleCSSStyle() : cssStyle.getMobileTitleCSSStyle()}>{path}</label>
                       </div>;
                   })
                }
            </div>
        );
    }
}


// WEBPACK FOOTER //
// ./src/com/sixdee/crbtportal/ui/components/navigation/navigationpathcomponent/navigationpathview.tsx